var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2755_4691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2755_4691)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 0H23V23H15.8125V0Z",
    fill: "#D9071E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H8.625V23H0V0Z",
    fill: "#3D58DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 0H15.8125V23H7.1875V0Z",
    fill: "#FBCD17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6101 18.7969L14.8532 19.3483L12.3444 13.2257L13.1013 12.6743L15.6101 18.7969ZM7.55658 18.9441L8.31348 19.4955L10.8223 13.3729L10.0654 12.8215L7.55658 18.9441Z",
    fill: "#FD1900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17801 8.99765V14.3177C8.17801 15.4995 7.4148 17.0396 7.02989 17.6126C6.64497 18.1856 5.88049 19.4983 5.88049 19.4983V5.18281C5.88049 3.57706 7.02989 3.02546 7.02989 3.02546C7.02989 3.02546 7.98426 3.27721 8.17801 5.18281V7.04003C8.4734 7.35019 9.45978 8.30142 10.097 7.89987C10.8536 7.42309 11.1149 6.05559 11.1149 6.05559C11.1149 6.05559 11.0441 4.6757 10.7336 4.6757C10.4231 4.6757 10.3982 2.73193 11.5875 2.73193C12.7768 2.73193 12.9154 3.48118 12.9154 4.07844C12.9154 4.39151 12.7272 4.89396 12.5481 5.3721C12.3855 5.8061 12.2304 6.22008 12.2304 6.45422C12.2304 6.94632 12.5085 7.89987 12.9154 7.89987C13.2008 7.89987 14.5735 7.18878 15.368 6.76404V5.18281C15.5617 3.27721 16.5161 3.02546 16.5161 3.02546C16.5161 3.02546 17.6655 3.57706 17.6655 5.18281V19.4983C17.6655 19.4983 16.901 18.1856 16.5161 17.6126C16.1312 17.0396 15.368 15.4995 15.368 14.3177V8.99765H8.17801ZM9.45172 19.0057C10.2291 18.3308 11.3663 15.3046 11.3663 15.3046L11.7438 15.4215C11.7438 15.4215 12.3203 17.426 14.0154 19.0057C12.2086 19.6486 11.7438 20.9396 11.7438 20.9396C11.7438 19.9068 9.45172 19.0057 9.45172 19.0057ZM9.32653 17.0901C9.85051 17.0901 10.2753 16.5538 10.2753 15.8922C10.2753 15.2306 9.85051 14.6943 9.32653 14.6943C8.80255 14.6943 8.37778 15.2306 8.37778 15.8922C8.37778 16.5538 8.80255 17.0901 9.32653 17.0901ZM14.8925 15.8922C14.8925 16.5538 14.4677 17.0901 13.9438 17.0901C13.4198 17.0901 12.995 16.5538 12.995 15.8922C12.995 15.2306 13.4198 14.6943 13.9438 14.6943C14.4677 14.6943 14.8925 15.2306 14.8925 15.8922Z",
    fill: "#A77B3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0694 9.97412L18.7292 10.3543L16.0414 18.6458L15.3816 18.2655L18.0694 9.97412Z",
    fill: "#FDFF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.935 7.50684H15.525V14.8274C15.525 14.8274 13.5937 15.6031 11.73 16.8759C10.3543 15.5151 7.935 14.8274 7.935 14.8274V7.50684Z",
    fill: "#E1E5E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2755_4691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 9,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.935 7.50684H15.525V14.8274C15.525 14.8274 13.5937 15.6031 11.73 16.8759C10.3543 15.5151 7.935 14.8274 7.935 14.8274V7.50684Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2755_4691)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.935,
    y: 12.2983,
    width: 7.59,
    height: 4.79167,
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.935,
    y: 7.50684,
    width: 7.59,
    height: 4.79167,
    fill: "#FD1900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3467 9.66196L10.7714 9.72543L11.1032 9.12872L10.7496 8.51074L11.3278 8.61001L11.5495 7.92855L11.7959 8.62453L12.3711 8.56105L12.0394 9.15777L12.3929 9.77574L11.8148 9.67648L11.5931 10.3579L11.3467 9.66196Z",
    fill: "#FDFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3141 8.31038C10.3141 8.31038 8.76884 9.56388 9.28392 10.4637C9.79901 11.3635 10.4474 11.4787 10.4474 11.4787C10.4474 11.4787 8.8667 14.6405 11.6488 16.4469C14.6273 14.7031 13.0608 11.4787 13.0608 11.4787C13.0608 11.4787 13.9777 11.2082 14.1613 10.2353C14.3448 9.26239 12.9629 8.14648 12.9629 8.14648C12.9629 8.14648 13.8251 9.81283 13.6283 10.2353C13.4314 10.6578 12.3769 11.0879 11.6488 11.0879C10.9206 11.0879 9.79618 10.8153 9.61471 10.0771C9.43325 9.33882 10.3141 8.31038 10.3141 8.31038Z",
    fill: "#FDFF00"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40448 11.0486C3.40448 11.0486 4.16213 12.2429 4.87554 11.8525C5.58894 11.462 5.41598 10.062 5.41598 10.062L4.87554 10.7157H4.41549V11.0486L4.05619 10.7157V11.0486H3.40448ZM3.9169 12.8839C3.9169 12.8839 4.84033 13.9578 5.46248 13.6543C6.08462 13.3508 5.9284 11.8973 5.9284 11.8973L5.38795 12.551H4.92791V12.8839L4.56861 12.551V12.8839H3.9169ZM6.40363 15.3208C5.78149 15.6243 4.85805 14.5505 4.85805 14.5505H5.50976V14.2175L5.86906 14.5505V14.2175H6.32911L6.86955 13.5638C6.86955 13.5638 7.02577 15.0174 6.40363 15.3208Z",
    fill: "#048F02"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0476 2.15479H9.3289V2.72556H8.9906V3.68389H9.3289V5.35583H10.0476V3.68389H10.4589V2.72556H10.0476V2.15479Z",
    fill: "#FDFF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8949 3.24365L9.23016 3.81544L10.8949 4.51683V3.24365Z",
    fill: "#DB4400"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2755_4691)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_4691",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdl);
export default __webpack_public_path__ + "static/media/MDL.189da5921b109055e77f7ae299c15b39.svg";
export { ForwardRef as ReactComponent };